import { connect } from 'react-redux';
import Forbidden from '../../components/Forbidden';

export default connect()(Forbidden);
